import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "./ui/sheet";

export default function InterviewSheet({ open, onOpenChange, side = "right", title, description, testId, children }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side={side} className="interview-overlay-sheet" data-testid={testId}>
        <SheetHeader className="interview-overlay-header">
          <SheetTitle>{title}</SheetTitle>
          <SheetDescription className="sr-only">
            {description || `${title} supporting information.`}
          </SheetDescription>
        </SheetHeader>
        <div className="interview-overlay-body">{children}</div>
      </SheetContent>
    </Sheet>
  );
}
